import { GCP_HOSTING_USER_PROMPT } from './gcpHostingDemoContent.js'

/** @param {string} trimmed */
function normalizeGcpHostingPrompt(trimmed) {
  return trimmed.trim().replace(/\s+/g, ' ').toLowerCase()
}

/** @param {string} trimmed */
export function isGcpHostingDemoPrompt(trimmed) {
  return normalizeGcpHostingPrompt(trimmed) === normalizeGcpHostingPrompt(GCP_HOSTING_USER_PROMPT)
}
